<div>
  @if (title) {
    <div class="my-2">
      <div class="row">
        <div class="col">
          <ion-label class="color-medium text-uppercase">{{ title }}</ion-label>
        </div>

        @if (this.information) {
          <div class="col-auto">
            <div class="pointer-hover" (click)="callInformation()">
              <i class="fa-regular fa-info-circle color-primary"></i>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (this.warningMode === LabelConfigurationWarningMode.NONE) {
    <div
      (click)="onTogglePress()"
      style="margin-left: -1.5rem !important; margin-right: -1.5rem !important"
      class="px-4 py-1 bg-white"
    >
      <ion-list lines="none">
        <ion-item class="pointer-hover">
          <ion-label>{{ nameCustom }}</ion-label>

          <div slot="end" class="color-primary pt-2">
            <ion-toggle [checked]="this.value"></ion-toggle>
          </div>
        </ion-item>
      </ion-list>
    </div>
  } @else if (this.warningMode === LabelConfigurationWarningMode.NEED_UPDATE) {
    <div
      style="
        margin-left: -1.5rem !important;
        margin-right: -1.5rem !important;
        opacity: 0.5;
        pointer-events: none !important;
      "
      class="px-4 py-1 bg-white"
    >
      <ion-list lines="none">
        <ion-item class="pointer-hover">
          <ion-label>
            {{ nameCustom }}
            <div>
              <div
                class="d-inline-block fs-12 bg-orange"
                style="color: white; border-radius: 15px; padding: 2px 10px"
              >
                {{ 'labelconfiguration.needupdate' | translate }}
              </div>
            </div>
          </ion-label>

          <div slot="end" class="color-primary pt-2">
            <ion-toggle [checked]="this.value"></ion-toggle>
          </div>
        </ion-item>
      </ion-list>
    </div>
  } @else if (this.warningMode === LabelConfigurationWarningMode.NEW) {
    <div
      style="margin-left: -1.5rem !important; margin-right: -1.5rem !important"
      class="px-4 py-1 bg-white"
      (click)="onTogglePress()"
    >
      <ion-list lines="none">
        <ion-item class="pointer-hover">
          <ion-label
            >{{ nameCustom }}
            <div>
              <div
                class="d-inline-block fs-12 warningColor"
                style="color: white; border-radius: 15px; padding: 2px 10px"
              >
                {{ 'labelconfiguration.new' | translate }}
              </div>
            </div>
          </ion-label>

          <div slot="end" class="color-primary pt-2">
            <ion-toggle [checked]="this.value"></ion-toggle>
          </div>
        </ion-item>
      </ion-list>
    </div>
  }

  @if (this.description) {
    <p class="my-3 mb-4 color-medium">
      {{ description }}
    </p>
  }
</div>
